// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"524":"c8f737ff","676":"88e8e9b7","852":"e83c4513"}[chunkId] + ".chunk.js";
};